import { takeLatest, put, call, delay, select } from "redux-saga/effects";
import axios from "../../utils/axios";
import log from "loglevel";

import getEnvParam from "../../utils/getEnvParam";
import { Creators as actionsConciliationResult } from '../ducks/conciliationResult'
import messages from "../../assets/i18n";
import convertBase64 from '../../helpers/convertBase64'
import { ALGODAO_BCI, DEMAIS_ATRIBUTOS_SUSTENTAVEIS } from '../../utils/constants';

const sustainabilityFromApi = (options = {}) => {
	return new Promise((resolve, reject) => {
		return axios.request(options)
			.then(response => response.status !== 200 ? reject(response) : response)
			.then(response => response.data)
			.then(response => resolve(response))
			.catch(error => {
				reject(error);
				log.info(error);
			});
	});
};

function* certificateConciliation(payload, token) {
	try {
		const { orderId, file, certificateMaterialCode, expeditionDate } = payload;

		const options = {
			method: "POST",
			headers: {
				"Content-Type": "application/graphql",
				"NPF_ROUTE": getEnvParam("REACT_APP_HEADER_SUSTENTABILIDADE"),
				"Authorization": token
			},
			data: `mutation {
					sustentabilidade(orderId: "${orderId}", file: "${file.result}", certificateMaterialCode: "${certificateMaterialCode ? certificateMaterialCode : ''}", dataExpedicao: "${expeditionDate ? expeditionDate : ''}")
				}`
		};

		const { data } = yield call(sustainabilityFromApi, options);

		const certificateStatus = data && data.sustentabilidade !== 0 ? true : false;

		yield put({
			type: "STATUS_CERTIFICATE",
			payload: certificateStatus
		});

		let result = { status: certificateStatus }

		return result
	} catch (error) {
		yield put({
			type: "STATUS_CERTIFICATE",
			payload: false
		});
		log.info(error);
	}
}

function* secondCertificateConciliation(payload, token) {
	try {
		const { orderId, file, certificateMaterialCode, expeditionDate } = payload;

		const options = {
			method: "POST",
			headers: {
				"Content-Type": "application/graphql",
				"NPF_ROUTE": getEnvParam("REACT_APP_HEADER_SUSTENTABILIDADE"),
				"Authorization": token
			},
			data: `mutation {
					sustentabilidade(orderId: "${orderId}", file: "${file.result}", certificateMaterialCode: "${certificateMaterialCode ? certificateMaterialCode : ''}", dataExpedicao: "${expeditionDate ? expeditionDate : ''}")
				}`
		};

		const { data } = yield call(sustainabilityFromApi, options);

		const certificateStatus = data && data.sustentabilidade !== 0 ? true : false;

		yield put({
			type: "STATUS_CERTIFICATE",
			payload: certificateStatus
		});

		let result = { status: certificateStatus }

		return result
	} catch (error) {
		yield put({
			type: "STATUS_CERTIFICATE",
			payload: false
		});
		log.info(error);
	}
}

function* UDADescription(payload, token) {
	try {
		const { orderId } = payload;

		const options = {
			method: "POST",
			headers: {
				"Content-Type": "application/graphql",
				"NPF_ROUTE": getEnvParam("REACT_APP_HEADER_PEDIDOS"),
				"Authorization": token
			},
			data: `query {				
					getDescricaoUDASustentabilidade(idPedido: "${orderId.id}", tipoCertificado: 2)
				}`
		};

		const data  = yield call(sustainabilityFromApi, options);
		
		return data
	} catch (error) {
		log.info(error);
	}
}

function* lastCertificateSustainability(payload, token) {
	try {
		const { id } = payload.payload;

		const options = {
			method: "POST",
			headers: {
				"Content-Type": "application/graphql",
				"NPF_ROUTE": getEnvParam("REACT_APP_HEADER_SUSTENTABILIDADE"),
				"Authorization": token
			},
			data: `{
				buscarUltimoCertificado(orderId: "${id}") {
					id
					status {
						id,
						descricao
					}
					dataCadastro
					dataExpedicao
					codigoCertificado
					idUDA
					codigoUDA
					descricaoUDA
					file
				}
			}`
		};

		const { data } = yield call(sustainabilityFromApi, options);

		if (data.buscarUltimoCertificado.length > 1) {	
			let tipoCertificado = data.buscarUltimoCertificado[0].dataExpedicao ? DEMAIS_ATRIBUTOS_SUSTENTAVEIS : ALGODAO_BCI
			
			yield put({
				type: "FILE_CERTIFICATE_SUSTAINABILITY",
				payload: data.buscarUltimoCertificado[0].file,
				tipo: tipoCertificado,
				uda: tipoCertificado === DEMAIS_ATRIBUTOS_SUSTENTAVEIS ? data.buscarUltimoCertificado[0].descricaoUDA : '',
				udaSecondFile: tipoCertificado === DEMAIS_ATRIBUTOS_SUSTENTAVEIS ? '' : data.buscarUltimoCertificado[1].descricaoUDA,
				payloadSecondFile: data.buscarUltimoCertificado[1].file
			});

		} else {
			let tipoCertificado = data.buscarUltimoCertificado[0].dataExpedicao ? DEMAIS_ATRIBUTOS_SUSTENTAVEIS : ALGODAO_BCI

			yield put({
				type: "FILE_CERTIFICATE_SUSTAINABILITY",
				payload: data.buscarUltimoCertificado[0].file,
				tipo: tipoCertificado,
				uda: tipoCertificado === DEMAIS_ATRIBUTOS_SUSTENTAVEIS ? data.buscarUltimoCertificado[0].descricaoUDA : '',
				udaSecondFile: '',
				payloadSecondFile: '',
			});
		}


		let result = '';

		return result
	} catch (error) {
		yield put({
			type: "STATUS_CERTIFICATE",
			payload: false
		});
		log.info(error);
	}
}

function* lastCertificateDetails(payload, token) {
	try {
		const { orderId, tipoCertificado } = payload;

		const options = {
			method: "POST",
			headers: {
				"NPF_ROUTE": getEnvParam("REACT_APP_HEADER_SUSTENTABILIDADE"),
				"Content-Type": "application/graphql",
				"Authorization": token
			},
			data:
			`query {
				buscarDetalhesUltimoCertificadoPorPedido(pedido: "${orderId}", tipoCertificado: ${tipoCertificado}) {
					id
					statusAuditoria
					orderId
					tipoCertificado
					codigoCertificado
					certificadoValido
					idUDA
					codigoUDA
					descricaoUDA
					conciliacaoAprovada
					avaliacao
					anotacoes
					dataExpedicao
					dataValidade
					certificadoComPeriodoVigenciaAtivo
					buyerIDNumberIgualALoja
					qtdBCCUs
					codigoODNRepetido
					codigoCertificadoODN
					qtdBCCUsDentroDaMargemDeErro
					nomeFornecedor
					semanaComercial
					naturezaPedido
				}
			}`
		};

		const { data } = yield call(sustainabilityFromApi, options);

		return data
	} catch (error) {
		log.info(error);
	}
}

function* certificateHistory(payload, token) {
	try {
		const { orderId, tipoCertificado } = payload;

		const options = {
			method: "POST",
			headers: {
				"NPF_ROUTE": getEnvParam("REACT_APP_HEADER_SUSTENTABILIDADE"),
				"Content-Type": "application/graphql",
				"Authorization": token
			},
			data:
			`query {
				buscarPorPedido(orderId: "${orderId}", tipoCertificado: ${tipoCertificado}) {
					id
					status {
						id
						descricao
					}
					dataCadastro
					file
				}
			}`
		};

		const { data } = yield call(sustainabilityFromApi, options);

		return data
	} catch (error) {
		log.info(error);
	}
}

function* editSustainabilityCertificate(payload, token) {
	try {
		const { 
				id, 
				statusId, 
				certificadoValido, 
				codigoCertificado, 
				file, 
				conciliacaoAprovada,
				avaliacao,
				anotacoes,
				dataExpedicao,
				dataValidade,
				certificadoComPeriodoVigenciaAtivo,
				buyerIDNumberIgualALoja,
				qtdBCCUs,
				codigoODNRepetido,
				codigoCertificadoODN,
				qtdBCCUsDentroDaMargemDeErro
		} = payload;
		var base64 = file ? yield convertBase64(file) : '';
		const options = {
			method: "POST",
			headers: {
				"NPF_ROUTE": getEnvParam("REACT_APP_HEADER_SUSTENTABILIDADE"),
				"Content-Type": "application/graphql",
				"Authorization": token
			},
			data:
			`mutation {
				atualizarInformacoesCertificado(
					sustentabilidadeDetalhesInput: {
						id: ${id}
						statusId: "${statusId}", 
						certificadoValido: "${certificadoValido ? certificadoValido : "Não"}",
						codigoCertificado: "${codigoCertificado}",
						file: "${base64}",
						${conciliacaoAprovada 				 ? ('conciliacaoAprovada: "' + conciliacaoAprovada + '"') : ''}
						${avaliacao 						 ? ('avaliacao: "' + avaliacao + '"') : ''}
						${anotacoes 						 ? ('anotacoes: "' + anotacoes + '"') : ''}
						${dataExpedicao 					 ? ('dataExpedicao: "' + dataExpedicao + '"') : ''}
						${dataValidade 						 ? ('dataValidade: "' + dataValidade + '"') : ''}
						${certificadoComPeriodoVigenciaAtivo ? ('certificadoComPeriodoVigenciaAtivo: "' + certificadoComPeriodoVigenciaAtivo + '"') : ''}
						${buyerIDNumberIgualALoja 			 ? ('buyerIDNumberIgualALoja: "' + buyerIDNumberIgualALoja + '"') : ''}
						${qtdBCCUs 							 ? ('qtdBCCUs: ' + qtdBCCUs) : ''}
						${codigoODNRepetido 				 ? ('codigoODNRepetido: "' + codigoODNRepetido + '"') : ''}
						${codigoCertificadoODN 		    	 ? ('codigoCertificadoODN: "' + codigoCertificadoODN + '"') : ''}
						${qtdBCCUsDentroDaMargemDeErro  	 ? ('qtdBCCUsDentroDaMargemDeErro: "' + qtdBCCUsDentroDaMargemDeErro + '"') : ''}
					}
				)
			}`
		};

		const { data } = yield call(sustainabilityFromApi, options);

		return data
	} catch (error) {
		log.info(error);
	}
}

function* sustainabilityList(token, page = 1, filter, size = 20) {
	try {
		const { 
			fornecedor, 
			numeroPedido, 
			statusAuditoria, 
			caracteristica,
			dataCriacaoInicial, 
			dataCriacaoFinal,
			dataPedidoInicial, 
			dataPedidoFinal,
			orderBy
		} = filter;

		const options = {
			method: "POST",
			headers: {
				"NPF_ROUTE": getEnvParam("REACT_APP_HEADER_SUSTENTABILIDADE"),
				"Content-Type": "application/graphql",
				"Authorization": token
			},
			data:
			`query {
				listarSustentabilidadeAuditoriaFiltrada(
					filtro: {
						fornecedor: "${fornecedor ? `${fornecedor}` : ''}"
						numeroPedido: "${numeroPedido ? `${numeroPedido}` : ''}"
						statusAuditoria: "${statusAuditoria ? `${statusAuditoria}` : ''}"
						caracteristica: "${caracteristica ? `${caracteristica}` : ''}"
						dataCriacaoInicial: "${dataCriacaoInicial ? `${dataCriacaoInicial}` : ''}"
						dataCriacaoFinal: "${dataCriacaoFinal ? `${dataCriacaoFinal}` : ''}"
						dataPedidoInicial: "${dataPedidoInicial ? `${dataPedidoInicial}` : ''}"
						dataPedidoFinal: "${dataPedidoFinal ? `${dataPedidoFinal}` : ''}"
					},
					maxResults: 20,
					page: ${page},
					orderBy: "${orderBy ? orderBy : ""}"
				 ) {
				 idCertificado
				 codigoCertificado
				 statusAuditoria
				 tipoCertificado
				 numeroPedido
				 naturezaPedido
				 fornecedor
				 dataCriacao
				 dataModificacao
				 dataExpedicao
				 certificadoValido
			 	}
		 	}`
		};

		const { data } = yield call(sustainabilityFromApi, options);

		return data
	} catch (error) {
		log.info(error);
	}
}

function* sustainabilityReport(token, filter) {
	try {
		const { 
			fornecedor, 
			numeroPedido, 
			statusAuditoria, 
			caracteristica,
			dataCriacaoInicial, 
			dataCriacaoFinal,
			dataPedidoInicial, 
			dataPedidoFinal 
		} = filter;

		const options = {
			method: "POST",
			headers: {
				"NPF_ROUTE": getEnvParam("REACT_APP_HEADER_SUSTENTABILIDADE"),
				"Content-Type": "application/graphql",
				"Authorization": token
			},
			data:
			`query {
				listarSustentabilidadeParaRelatorio(
					filtro: {
						fornecedor: "${fornecedor ? `${fornecedor}` : ''}"
						numeroPedido: "${numeroPedido ? `${numeroPedido}` : ''}"
						statusAuditoria: "${statusAuditoria ? `${statusAuditoria}` : ''}"
						caracteristica: "${caracteristica ? `${caracteristica}` : ''}"
						dataCriacaoInicial: "${dataCriacaoInicial ? `${dataCriacaoInicial}` : ''}"
						dataCriacaoFinal: "${dataCriacaoFinal ? `${dataCriacaoFinal}` : ''}"
						dataPedidoInicial: "${dataPedidoInicial ? `${dataPedidoInicial}` : ''}"
						dataPedidoFinal: "${dataPedidoFinal ? `${dataPedidoFinal}` : ''}"
					},
					maxResults: 10000,
				 ) {
				 id			
				 statusAuditoria
				 orderId
				 codigoCertificado
				 tipoCertificado
				 idUDA
				 codigoUDA
				 descricaoUDA
				 certificadoValido
				 conciliacaoAprovada
				 avaliacao
				 anotacoes
				 dataCadastro
				 dataExpedicao
				 dataValidade
				 certificadoComPeriodoVigenciaAtivo
				 qtdBCCUs
				 codigoODNRepetido
				 codigoCertificadoODN
				 qtdBCCUsDentroDaMargemDeErro
				 nomeFornecedor
				 semanaComercial
				 naturezaPedido
				 qtdePecas
			 	}
		 	}`
		};

		const { data } = yield call(sustainabilityFromApi, options);

		return data
	} catch (error) {
		log.info(error);
	}
}

function* downloadSustainabilityFile(payload, token) {
	try {
		const options = {
			method: "POST",
			headers: {
				"NPF_ROUTE": getEnvParam("REACT_APP_HEADER_SUSTENTABILIDADE"),
				"Content-Type": "application/graphql",
				"Authorization": token
			},
			data:
			`query {
				buscarArquivoPorIdCertificado (id: ${payload.payload})
			}
			`
		};

		const { data } = yield call(sustainabilityFromApi, options);

		return data
	} catch (error) {
		log.info(error);
	}
}

function* sustainability(payload) {
	try {
		const { token } = yield select(state => state.authentication);

		yield put(actionsConciliationResult.conciliationResultLoading(true));

		yield delay(2000);
	
		yield call(certificateConciliation, payload, token);
		
	} catch (error) {
		log.info(error);
	} finally {
        yield put(actionsConciliationResult.conciliationResultLoading(false));
    }
}

function* secondSustainability(payload) {
	try {
		const { token } = yield select(state => state.authentication);

		yield put(actionsConciliationResult.conciliationResultLoading(true));

		yield delay(2000);
	
		yield call(secondCertificateConciliation, payload, token);
		
	} catch (error) {
		log.info(error);
	} finally {
        yield put(actionsConciliationResult.conciliationResultLoading(false));
    }
}

function* getUDADescription(payload) {
	try {
		const { token } = yield select(state => state.authentication);

		const result = yield call(UDADescription, payload, token);

		if (result && result.data && result.data.getDescricaoUDASustentabilidade) {
			yield put({ 
				type: "SET_UDA_DESCRIPTION", 
				payload: result.data.getDescricaoUDASustentabilidade
			});
		}
	} catch (error) {
		log.info(error);
	}
}

function* getLastCertificateSustainability(payload) {
	try {
		const { token } = yield select(state => state.authentication);

		yield put(actionsConciliationResult.fileCertificateSustainabilityLoading());
		yield call(lastCertificateSustainability, payload, token);
		yield put(actionsConciliationResult.fileCertificateSustainabilityComplete());
	
	} catch (error) {
		log.info(error);
	}
}

function* getLastCertificateDetails(payload) {
	try {
		const { token } = yield select(state => state.authentication);
		//BUGFIX - CLEAR LAST CERTIFICATE DETAILS
		yield put({ type: "SET_LAST_CERTIFICATE_DETAILS", payload: {buscarDetalhesUltimoCertificadoPorPedido: {}} });


		yield put({ type: "SET_LOADING_STATUS_PAGE", payload: true});
		yield put({ type: "UNSET_SELECTED_CERTIFICATE"});
		const result = yield call(lastCertificateDetails, payload, token);
		yield put({ type: "SET_LOADING_STATUS_PAGE", payload: false});

		if (result && result.buscarDetalhesUltimoCertificadoPorPedido) {
			let statusIdAuditoria = result.buscarDetalhesUltimoCertificadoPorPedido.statusAuditoria
			let certificadoValido = result.buscarDetalhesUltimoCertificadoPorPedido.certificadoValido

			if (statusIdAuditoria) {
				if (statusIdAuditoria === "AGUARDANDO APROVAÇÃO") {
					statusIdAuditoria = "0"
				}

				if (statusIdAuditoria === "APROVADO") {
					statusIdAuditoria = "1"
				}

				if (statusIdAuditoria === "REPROVADO") {
					statusIdAuditoria = "2"
				}
			} else {
				statusIdAuditoria = "0"
			}

			if (certificadoValido) {
				if (certificadoValido === "Sim" || certificadoValido === "S" || certificadoValido === 1) {
					certificadoValido = "Sim"
				}
			} else {
				certificadoValido = "Não"
			}

			let finalResult = result
			finalResult.buscarDetalhesUltimoCertificadoPorPedido.statusId = statusIdAuditoria
			finalResult.buscarDetalhesUltimoCertificadoPorPedido.certificadoValido = certificadoValido

            yield put({ type: "SET_LAST_CERTIFICATE_DETAILS", payload: finalResult });
        }
	} catch (error) {
		log.info(error);
	}
}

function* getOrderCertificateHistory(payload) {
	try {
		const { token } = yield select(state => state.authentication);

		const result = yield call(certificateHistory, payload, token);

		if (result) {
            yield put({ type: "SET_CERTIFICATE_HISTORY_LIST", payload: result});
        }
	} catch (error) {
		log.info(error);
	}
}

function* updateSustainabilityCertificate(payload) {
	try {
		yield put({ type: "SET_LOADING_SUSTAINABILITY_SAVE", payload: true });

		const { token } = yield select(state => state.authentication);

        const lang = yield select(state => state.language.name);

		const result = yield call(editSustainabilityCertificate, payload.payload, token);

		if (result && result.atualizarInformacoesCertificado === "") {
			yield put({ 
				type: "SET_SUSTAINABILITY_TOAST", 
				payload: {
					showToast: true,
					message: messages[lang].registerSuccess,
					messageType: "toast-success"
				}});
			yield put({ type: "SUSTAINABILITY_DETAILS_RELOAD", payload: true });
        } else {
			yield put({ 
				type: "SET_SUSTAINABILITY_TOAST", 
				payload: {
					showToast: true,
					message: messages[lang].registerError,
					messageType: "toast-error"
				}});
		}
		yield put({ type: "SET_LOADING_SUSTAINABILITY_SAVE", payload: false });
	} catch (error) {
		log.info(error);
	}
}

function* getSustainabilityList({page, filter, cleanTable}) {
	try {
		const { token } = yield select(state => state.authentication);		
		const nextPage = page + 1;
		let result

		yield put({ 
			type: "SUSTAINABILITY_HAS_MORE_LOADING", 
			payload: true
		});

		if (cleanTable) {
			yield put({ 
				type: "CLEAN_SUSTAINABILITY_LIST",
			});
		}

		result = yield call(sustainabilityList, token, page, filter);
	
		if (result) {
			if (result.listarSustentabilidadeAuditoriaFiltrada && result.listarSustentabilidadeAuditoriaFiltrada.length) {
				yield put({ 
					type: "SET_SUSTAINABILITY_LIST", 
					payload: {
						list: result.listarSustentabilidadeAuditoriaFiltrada,
						hasMore: true,
						page: nextPage,
					}
				});
			} else {
				yield put({ 
					type: "SET_SUSTAINABILITY_LIST", 
					payload: {
						list: result.listarSustentabilidadeAuditoriaFiltrada,
						hasMore: false,
						page: page,
					}
				});
			}
        }

		yield put({ 
			type: "SUSTAINABILITY_HAS_MORE_LOADING", 
			payload: false
		});
	} catch (error) {
		log.info(error);
	}
}

function* getDownloadSustainabilityFile(payload) {
	try {
		yield put({ type: "DOWNLOAD_SUSTAINABILITY_LOADING", payload: true});

		const { token } = yield select(state => state.authentication);

		const result = yield call(downloadSustainabilityFile, payload, token);

		if (result && result.buscarArquivoPorIdCertificado) {
            yield put({ type: "DOWNLOAD_SUSTAINABILITY_FILE", payload: result.buscarArquivoPorIdCertificado});
        }
	} catch (error) {
		log.info(error);
	} finally {
		yield put({ type: "DOWNLOAD_SUSTAINABILITY_LOADING", payload: false});
	}
}

function* getSustainabilityReport({filter}) {
	try {
		yield put({ type: "SET_LOADING_SUSTAINABILITY_REPORT", payload: true });

		const { token } = yield select(state => state.authentication)

		const result = yield call(sustainabilityReport, token, filter);

		if (result && result.listarSustentabilidadeParaRelatorio) {
            yield put({ type: "SET_SUSTAINABILITY_CSV_LIST", payload: result.listarSustentabilidadeParaRelatorio});
        }
		yield put({ type: "SET_LOADING_SUSTAINABILITY_REPORT", payload: false });
	} catch (error) {
		yield put({ type: "SET_LOADING_SUSTAINABILITY_REPORT", payload: false });
		log.info(error);
	}
}

// //Generator function
export function* sustainabilityWatcher() {
	yield takeLatest("SUSTAINABILITY_CERTIFICATE_REQUEST", sustainability);
	yield takeLatest("SECOND_SUSTAINABILITY_CERTIFICATE_REQUEST", secondSustainability);	
	yield takeLatest("GET_LAST_CERTIFICATE_SUSTAINABILITY", getLastCertificateSustainability);
	yield takeLatest("GET_LAST_CERTIFICATE_DETAILS", getLastCertificateDetails);
	yield takeLatest("GET_ORDER_CERTIFICATE_HISTORY", getOrderCertificateHistory);
	yield takeLatest("UPDATE_SUSTAINABILITY_CERTIFICATE", updateSustainabilityCertificate);
	yield takeLatest("GET_SUSTAINABILITY_LIST", getSustainabilityList);
	yield takeLatest("GET_DOWNLOAD_SUSTAINABILITY_FILE", getDownloadSustainabilityFile);
	yield takeLatest("GET_SUSTAINABILITY_REPORT", getSustainabilityReport);
	yield takeLatest("GET_UDA_DESCRIPTION", getUDADescription);
}
